<template>
  <div class="background_white">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "verify",
  // onMount: () => {
  //     var session = {
  //         id:,
  //         documents: {
  //             files: [],

  //         }
  //     };

  //     // generate urls to s3
  //     // -> Send the session to the api
  //     // -> return the x number of generated urls
  //     // -> upload to s3
  //     // upload
  //     // return back to site
  // }
};
</script> 

<style>
.background_white {
  background: white;
}
</style>